var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 21.53-1.15-1.66c-2.27-3.25-5.1-7.3-5.1-11.16 0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25c0 3.86-2.83 7.92-5.11 11.17L12 21.52zm0-17.56c-2.62 0-4.75 2.13-4.75 4.75 0 3.34 2.61 7.13 4.75 10.19 2.14-3.06 4.75-6.84 4.75-10.19 0-2.62-2.13-4.75-4.75-4.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.47c-1.52 0-2.75-1.23-2.75-2.75S10.48 5.97 12 5.97s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75m0-4a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  })));
};
export default SvgPin;